import { render, staticRenderFns } from "./CphConfig.vue?vue&type=template&id=2c8ef7c0&"
import script from "./CphConfig.vue?vue&type=script&lang=js&"
export * from "./CphConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports